export enum BilletSubjectType {
    VEHICLE = 'VEHICLE',
    USER = 'USER',
}
